export enum StatusPOS {
    POSActive = 1,
    POSDisabled = 2,
    POSDeleted = 3
  }
